<template>
  <div class="pay-detail">
    <div class="pay-detail-vip" v-if="!isJiangxi" v-loading="vipLoading">
      <CommonTable
        tableType="会员购买详情"
        :keys="vipKeys"
        :count="vipCount"
        :list="vipList"
        @changePagingParams="changeVipPaging"
        @download="downloadVip"
        :border="true"
      />
    </div>
    <div
      id="pay-detail-code"
      :class="[isJiangxi ? '' : 'pay-detail-code']"
      v-loading="codeLoading"
    >
      <CommonTable
        ref="pay-detail-code"
        tableType="激活码开通详情"
        :keys="codeKeys"
        :count="codeCount"
        :list="codeList"
        @changePagingParams="changeCodePaging"
        @download="downloadCode"
        :border="true"
      >
        <template v-slot:table-filter>
          <div class="slot-box">
            <div class="slot-box-left">
              <SelectCom
                placeholder="请选择激活码状态"
                v-model="codeParams.status"
                :options="statusList"
              />
              <SelectCom
                placeholder="请选择激活码类型"
                v-model="codeParams.type"
                :options="typeList"
              />
            </div>
            <div class="slot-box-right">
              <SelectRemoteCom
                placeholder="输入学校名"
                :clearable="true"
                :getListFunc="getSchoolListFunc"
                v-model="codeParams.schoolId"
                :filterName="codeParams.schoolName"
              />
              <SelectRemoteCom
                placeholder="输入标题名"
                :clearable="true"
                :getListFunc="getCodeFunc"
                v-model="codeParams.recordId"
                :filterName="codeParams.recordTitle"
              />
            </div>
          </div>
        </template>
      </CommonTable>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { exportXlsx } from '@/utils/common'
import moment from 'moment'
import CommonTable from '../common/CommonTable'
import SelectCom from '../common/SelectCom'
import SelectRemoteCom from '../common/SelectRemoteCom'
import _ from 'lodash'

export default {
  name: 'PayDetail',
  components: {
    CommonTable,
    SelectCom,
    SelectRemoteCom
  },
  data() {
    return {
      vipLoading: false,
      vipKeys: [
        {
          prop: 'username',
          label: '账号'
        },
        {
          prop: 'schoolName',
          label: '学校'
        },
        {
          prop: 'orgNames',
          label: '机构'
        },
        {
          prop: 'regionName',
          label: '所属区域'
        },
        {
          prop: 'usernameRole',
          label: '账号身份'
        },
        {
          prop: 'productName',
          label: '购买类型'
        },
        {
          prop: 'buyTime',
          label: '购买时间'
        },
        {
          prop: 'amount',
          label: '价格'
        }
      ],
      vipCount: 0,
      vipList: [],
      vipParams: {
        page: 1,
        pageSize: 10
      },

      codeLoading: false,
      codeKeys: [
        {
          prop: 'title',
          label: '标题'
        },
        {
          prop: 'key',
          label: '激活码'
        },
        {
          prop: 'codeType',
          label: '激活码类型'
        },
        {
          prop: 'status',
          label: '激活码状态'
        },
        {
          prop: 'username',
          label: '账号'
        },
        {
          prop: 'schoolName',
          label: '学校'
        },
        {
          prop: 'orgNames',
          label: '机构'
        },
        {
          prop: 'regionName',
          label: '使用区域'
        },
        {
          prop: 'activateTime',
          label: '激活时间'
        }
      ],
      codeCount: 0,
      codeList: [],
      codeParams: {
        status: '',
        type: '',
        schoolId: '',
        schoolName: '',
        recordId: '',
        recordTitle: ''
      },
      codePagingParams: {
        page: 1,
        pageSize: 10
      },
      statusList: [
        {
          value: 0,
          label: '未激活'
        },
        {
          value: 1,
          label: '已激活'
        },
        {
          value: 2,
          label: '已无效'
        }
      ],
      typeList: [
        {
          value: 'campus',
          label: '校本'
        },
        {
          value: '430',
          label: '社团'
        },
        {
          value: 'org',
          label: '机构'
        },
        {
          value: 'vip',
          label: '会员'
        }
      ],

      timer: null
    }
  },
  created() {
    this.onGetVipOrders()
    const {
      schoolId = '',
      schoolName = '',
      recordId = '',
      recordTitle = '',
      scrollTo = ''
    } = this.$route.query
    this.codeParams = {
      ...this.codeParams,
      schoolId: schoolId && +schoolId,
      schoolName,
      recordId: recordId && +recordId,
      recordTitle
    }
    if (scrollTo === 'code') {
      this.scrollToCode()
    }
  },
  watch: {
    codeParams: {
      handler() {
        this.$refs['pay-detail-code'].handleSizeChange(10)
      },
      deep: true
    },
    codePagingParams: {
      handler() {
        this.debounce()
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters({
      userDetail: 'customer/userDetail'
    }),
    customerName() {
      return _.get(this.userDetail, 'username')
    },
    isJiangxi() {
      return this.customerName === 'jxplk'
    }
  },
  methods: {
    ...mapActions({
      getVipOrders: 'newStat/getVipOrders',
      getActivateCodes: 'newStat/getActivateCodes',
      getSchoolList: 'newStat/getSchoolList',
      getActivateCodeList: 'newStat/getActivateCodeList'
    }),
    changeVipPaging(paging) {
      this.vipParams = paging
      this.onGetVipOrders()
    },
    async downloadVip() {
      const { rows } = await this.getVipOrdersFunc(true)
      if (rows.length > 0) {
        exportXlsx('会员购买列表', this.vipKeys, rows)
      } else {
        this.$message.warning('暂时没有数据')
      }
    },
    async onGetVipOrders() {
      this.vipLoading = true
      const { count, rows } = await this.getVipOrdersFunc()
      this.vipCount = count
      this.vipList = rows
      this.vipLoading = false
    },
    async getVipOrdersFunc(noPage = false) {
      let params = {
        noPage
      }
      if (noPage === false) {
        params = {
          ...params,
          'x-page': this.vipParams.page,
          'x-per-page': this.vipParams.pageSize
        }
      }
      const { count, rows } = await this.getVipOrders(params)
      const list = rows.map(item => {
        const {
          username = '',
          schoolName = '',
          orgNames = '',
          regionName = '',
          isCampus = 0,
          is430 = 0,
          isOrg = 0,
          productName = '',
          updatedAt = '',
          amount = 0
        } = item
        const usernameRoleArr = []
        if (isCampus) {
          usernameRoleArr.push('校本')
        }
        if (is430) {
          usernameRoleArr.push('社团')
        }
        if (isOrg) {
          usernameRoleArr.push('机构')
        }
        return {
          username,
          schoolName,
          orgNames: orgNames && orgNames.replace(/,/g, '、'),
          regionName,
          usernameRole: usernameRoleArr.join('、'),
          productName,
          buyTime: updatedAt && moment(updatedAt).format('YYYY-MM-DD HH:mm'),
          amount: `${amount / 100}元`
        }
      })
      return {
        count,
        rows: list
      }
    },

    changeCodePaging(paging) {
      this.codePagingParams = paging
    },
    async downloadCode() {
      const { rows } = await this.getActivateCodesFunc(true)
      if (rows.length > 0) {
        exportXlsx('激活码开通列表', this.codeKeys, rows)
      } else {
        this.$message.warning('暂时没有数据')
      }
    },
    debounce: _.debounce(function() {
      this.onGetActivateCodes()
    }, 300),
    async onGetActivateCodes() {
      this.codeLoading = true
      const { count, rows } = await this.getActivateCodesFunc()
      this.codeCount = count
      this.codeList = rows
      this.codeLoading = false
    },
    async getActivateCodesFunc(noPage = false) {
      const {
        status = '',
        type = '',
        schoolId = '',
        recordId = ''
      } = this.codeParams
      let params = {
        noPage
      }
      if (noPage === false) {
        params = {
          ...params,
          'x-page': this.codePagingParams.page,
          'x-per-page': this.codePagingParams.pageSize
        }
      }
      if (status !== '') {
        params.status = status
      }
      if (schoolId !== '') {
        params.schoolId = schoolId
      }
      if (recordId !== '') {
        params.recordId = recordId
      }
      if (type !== '') {
        params.roleTag = type
      }
      const { count, rows } = await this.getActivateCodes(params)
      const list = rows.map(item => {
        const {
          key = '',
          title = '',
          schoolName = '',
          username = '',
          status = '',
          activateTime = '',
          orgNames = '',
          tag = '',
          regions = []
        } = item
        const curStatus = this.statusList.find(ele => ele.value === status)
        const curTag = this.typeList.find(ele => ele.value === tag)
        return {
          key: key.replace(/(.{4})/g, '$1 '),
          title,
          codeType: curTag && curTag.label,
          schoolName,
          orgNames,
          username,
          status: curStatus && curStatus.label,
          regionName: regions.map(item => item.fullname).join('，'),
          activateTime:
            activateTime && moment(activateTime).format('YYYY-MM-DD HH:mm')
        }
      })
      return {
        count,
        rows: list
      }
    },
    async getSchoolListFunc(val) {
      const params = {
        isActive: false
      }
      if (val) {
        params.name = val
      }
      const { rows } = await this.getSchoolList(params)
      return rows.map(item => {
        return {
          id: item.schoolId,
          name: item.schoolName
        }
      })
    },
    async getCodeFunc(val) {
      const params = {}
      if (val) {
        params.title = val
      }
      const { rows } = await this.getActivateCodeList(params)
      return rows.map(item => {
        return {
          id: item.id,
          name: item.title
        }
      })
    },
    scrollToCode() {
      this.$nextTick(() => {
        this.timer = setTimeout(() => {
          const payDetailCodeDom = document.getElementById('pay-detail-code')
          window.scrollTo(0, payDetailCodeDom.offsetTop + 90)
        }, 1000)
      })
    }
  },
  beforeDestroy() {
    clearTimeout(this.timer)
  }
}
</script>

<style lang="scss">
.pay-detail-code {
  margin-top: 20px;
}
</style>
